import startOfDay from 'date-fns/startOfDay';
import subDays from 'date-fns/subDays';
import React, { Suspense, useMemo } from 'react';

import { SettingsPageFrame, TableSkeleton } from '@eluve/blocks';
import { useTranslation } from '@eluve/i18n';
import { useAssignedTenantIdFromParams } from '@eluve/session-helpers';

import {
  RECOVERY_WINDOW_DAYS,
  RegenerateNotesTable,
} from './RegenerateNotesTable';

const RegenerateNotesContent: React.FC = () => {
  const tenantId = useAssignedTenantIdFromParams();

  // Computed here (the page does not suspend) and truncated to the start of the
  // day so it stays stable across the table's suspense retries.
  const since = useMemo(
    () => startOfDay(subDays(new Date(), RECOVERY_WINDOW_DAYS)).toISOString(),
    [],
  );

  return (
    <Suspense fallback={<TableSkeleton rowCount={10} />}>
      <RegenerateNotesTable tenantId={tenantId} since={since} />
    </Suspense>
  );
};

export const RegenerateNotesPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <SettingsPageFrame
      size="wide"
      title={t('tenantAdmin.noteRecovery.title')}
      description={t('tenantAdmin.noteRecovery.description')}
    >
      <RegenerateNotesContent />
    </SettingsPageFrame>
  );
};
